import { Dayjs } from "dayjs"
import { ISupplyHistory } from "./meterpointSupplyHistory.types"

export class SupplyHistory implements ISupplyHistory {
  id: number
  date: Dayjs
  eventType: string
  supplyStatus: string

  constructor(
    id: number,
    date: Dayjs,
    eventType: string,
    supplyStatus: string,
  ) {
    this.id = id
    this.date = date
    this.eventType = eventType
    this.supplyStatus = supplyStatus
  }
}
